// Utility to append query params to a URL, handling ?/& correctly
export default function appendQueryParams(url: string, queryParams: string | undefined): string {
  if (!queryParams) return url;
  return url + (url.includes('?') ? '&' : '?') + queryParams;
}
